"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeWidgetInPanelHeight = void 0;
const command_manager_1 = require("../../command_manager");
const selectors_1 = require("../../exports/store/selectors");
const model_1 = require("../../model");
exports.changeWidgetInPanelHeight = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { widgetId, resourceId, resourceType, panelId, widgetHeight } = options;
        const widgetPanels = (0, selectors_1.getResourceWidgetPanels)(state, resourceId, resourceType);
        if (!widgetPanels) {
            return null;
        }
        const widgetPanelIndex = widgetPanels.findIndex(item => item.id === panelId);
        if (widgetPanelIndex < 0) {
            return null;
        }
        const widgets = widgetPanels[widgetPanelIndex].widgets;
        const widgetIndex = widgets.findIndex(item => item.id === widgetId);
        if (widgetIndex < 0) {
            return null;
        }
        const changeWidgetHeightAction = model_1.DatasheetActions.changeWidgetHeight2Action(state, { widgetIndex, widgetPanelIndex, widgetHeight, resourceId, resourceType });
        if (!changeWidgetHeightAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId,
            resourceType,
            actions: changeWidgetHeightAction,
        };
    },
};
//# sourceMappingURL=change_widget_in_panel_height.js.map